import React, { Fragment } from 'react';
import {
  MOBILE_LV_LABEL_CLASS,
  MOBILE_LV_VALUE_CLASS,
  MOBILE_LV_CARD_CLASS,
  MOBILE_LV_GRID_CLASS,
  MOBILE_LV_LABEL_LAST,
  MOBILE_LV_VALUE_LAST,
} from '../../Constants/mobileLabelValueTable';

const SimpleTable = ({
  columns = [],
  data = [],
  /** Max height of the scroll area; table grows with rows up to this cap */
  scrollHeight = '60vh',
}) => {
  const renderCell = (column, row) => {
    if (column.renderCell) return column.renderCell(row);
    if (column.cell) return column.cell(row);
    return row[column.selector];
  };

  return (
    <div className="relative w-full min-h-0">
      {/* Desktop */}
      <div className="hidden md:block overflow-x-auto">
        <div className="inline-block min-w-full align-middle">
          <div className="overflow-hidden">
            <div
              className="overflow-y-auto shadow"
              style={{ maxHeight: scrollHeight }}
            >
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50 sticky top-0 z-10">
                  <tr>
                    {columns.map((column, index) => (
                      <th
                        key={index}
                        scope="col"
                        className={`px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider bg-gray-50 sticky top-0 ${column.headerClassName || 'text-left'}`}
                        style={{ position: 'sticky', top: 0, zIndex: 10 }}
                      >
                        {column.name}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {data.length > 0 ? (
                    data.map((row, index) => (
                      <tr key={index} className="hover:bg-gray-50">
                        {columns.map((column, colIndex) => (
                          <td key={colIndex} className="px-6 py-4 whitespace-nowrap">
                            <div className="text-sm text-gray-900">
                              {renderCell(column, row)}
                            </div>
                          </td>
                        ))}
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={columns.length} className="px-6 py-4 text-center text-sm text-gray-500">
                        No results found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      {/* Mobile: label–value cards */}
      <div className="md:hidden px-2 pb-2 space-y-4">
        {data.length === 0 ? (
          <p className="text-center text-sm text-gray-500 py-6">No results found</p>
        ) : (
          data.map((row, rowIndex) => (
            <article key={rowIndex} className={MOBILE_LV_CARD_CLASS}>
              <div className={MOBILE_LV_GRID_CLASS}>
                {columns.map((column, colIndex) => {
                  const isLast = colIndex === columns.length - 1;
                  const labelCls = `${MOBILE_LV_LABEL_CLASS}${isLast ? MOBILE_LV_LABEL_LAST : ''}`;
                  const valueCls = `${MOBILE_LV_VALUE_CLASS}${isLast ? MOBILE_LV_VALUE_LAST : ''}`;
                  return (
                    <Fragment key={column.name || colIndex}>
                      <div className={labelCls}>{column.name}</div>
                      <div className={valueCls}>
                        <div className="text-sm text-gray-900">{renderCell(column, row)}</div>
                      </div>
                    </Fragment>
                  );
                })}
              </div>
            </article>
          ))
        )}
      </div>
    </div>
  );
};

export default SimpleTable;
